"use client";
/* eslint-disable @next/next/no-img-element */
import { useCallback, useEffect } from "react";
import { useState } from "react";
import { configuration } from "../../helpers/config";
import { ReactImageTurntable } from "react-image-turntable";
import useIsMobile from "../../hooks/useIsMobile";
import SelectInput from "../forms/utils/selectinput";

const CAR_CONTANTS=require("./../../helpers/constants")
const ExteriorViewer = (props) => {
  const isMobile = useIsMobile();
  const { height, colorsArr } = props;
  const [overlayVisibility, setOverlayVisibility] = useState(true);
  const [selectedColor, setSelectedColor] = useState({
    name: colorsArr[0].name,
    index: 0,
    // imgArr: colorsArr[0]?.exteriorImages
    imgArr: colorsArr[0]?.extStaticImage
      ? isMobile
        ? colorsArr[0]?.staticExtImageMobile
        : colorsArr[0]?.staticExtImageDesktop
      : colorsArr[0]?.exteriorImages,
    extStaticImage: colorsArr[0]?.extStaticImage,
    staticExtImageDesktop:colorsArr[0]?.staticExtImageDesktop[0],
    staticExtImageMobile: colorsArr[0]?.staticExtImageMobile[0]
  });
  const mobile = useIsMobile();
  const changeVisibility = () => {
    setTimeout(() => {
      setOverlayVisibility(true);
    }, 3000);
  };

  const circleLength = {
    4: "25%",
    3: "33%",
    2: "50%",
    1: "100%",
  };

  const circleContainerWidth = {
    4: "100%",
    3: "75%",
    2: "50%",
    1: "25%",
  };

  const[colorArray , setcolorArray]=useState([])
 
  const getExteriorInteriorData = () => {

    if (props?.configuratorData?.variants?.length > 0) {
      let defaultVariant = props?.configuratorData?.variants?.find(
        (x) => x.is_default === true
      );

      let defaultColorArr = [];

      if (defaultVariant) {
        defaultColorArr = defaultVariant?.colors;
      } else {
        defaultColorArr = props?.configuratorData?.variants[0]?.colors;
      }

      const colorArr = [];
      defaultColorArr?.map((x) => {
        let obj = {
          name: "",
          value1: "",
          value2: "",
          exteriorImages: "",
          // extStaticImage:props?.data?.configuratorData?.ExtStaticImageToggle
        };
        obj.name = x?.color_name;
        // obj.value = `${configuration.IMG_URL}${x?.exterior_images[3]?.value}`;
        obj.value1 = x.hex_code;
        obj.value2 = x.hex_code2;
        obj.exteriorImages = x?.exterior_images?.map((x) => {
          return `${configuration.IMG_URL}${x?.value}`;
        });
        obj.extStaticImage = x?.ExtStaticImageToggle
          ? x?.ExtStaticImageToggle
          : props?.data?.configuratorData?.ExtStaticImageToggle;
        // obj.staticExtImage=x?.static_image_exterior
        obj.staticExtImageDesktop = [
          `${configuration.IMG_URL}${x?.static_image_exterior?.desktop}`,
        ];
        obj.staticExtImageMobile = [
          `${configuration.IMG_URL}${x?.static_image_exterior?.mobile}`,
        ];

        colorArr.push(obj);
      });
      setcolorArray(colorArr);
    }
  };

  useEffect(() => {
    getExteriorInteriorData();
  }, [props?.data?.configuratorData]);


  const handleSelectChange = (e) => {
    try {
      // Parse the value from the event
      const parsedValue = JSON.parse(e.target.value);
      const colors = [];
      props?.configuratorData.variants.map((item)=>{
        if(item.variant_code == parsedValue.variant_code){
          colors = item?.colors
        }
      })
      
      // Prepare an array of color objects
      const arr = colors.map((x) => {
        return {
          name: x?.color_name || "",
          value1: x?.hex_code || "",
          value2: x?.hex_code2 || "",
          exteriorImages: x?.exterior_images?.map((img) => `${configuration.IMG_URL}${img?.value}`) || [],
          extStaticImage: x?.ExtStaticImageToggle 
            ? x.ExtStaticImageToggle 
            : props?.data?.configuratorData?.ExtStaticImageToggle,
          staticExtImageDesktop: x?.static_image_exterior?.desktop
            ? [`${configuration.IMG_URL}${x.static_image_exterior.desktop}`]
            : [],
          staticExtImageMobile: x?.static_image_exterior?.mobile
            ? [`${configuration.IMG_URL}${x.static_image_exterior.mobile}`]
            : [],
        };
      });
      // Update the state with the new array
      setcolorArray(arr);
    } catch (error) {
      console.error("Error handling select change:", error);
    }
  };

  useEffect(()=>{
      setSelectedColor({
        name: colorArray[0]?.name,
        index: 0,
        imgArr: colorArray[0]?.extStaticImage
          ? isMobile
            ? colorArray[0]?.staticExtImageMobile
            : colorArray[0]?.staticExtImageDesktop
          : colorArray[0]?.exteriorImages || [],
        extStaticImage: colorArray[0]?.extStaticImage,
        staticExtImageDesktop:colorsArr[0]?.staticExtImageDesktop[0],
        staticExtImageMobile: colorsArr[0]?.staticExtImageMobile[0]
      })
    // })

    },[colorArray])

  return (
    <div className="grid grid-cols-12">
      <div
        className="lg:col-span-8 col-span-12"
        onMouseDown={() => setOverlayVisibility(false)}
        onMouseUp={() => changeVisibility()}
      >
        <div className="relative">
          {/*<ReactImageTurntable*/}
          {/*  autoRotate={{ disabled: true }}*/}
          {/*  // style={{ minHeight: "50vh", height: "100%" }}*/}
          {/*  images={*/}
          {/*    props?.configuratorData?.ExtStaticImageToggle*/}
          {/*      ? [*/}
          {/*          `${configuration.IMG_URL}${*/}
          {/*            mobile*/}
          {/*              ? props?.configuratorData?.staticImgDefault?.exterior*/}
          {/*                  ?.mob_img*/}
          {/*              : props?.configuratorData?.staticImgDefault?.exterior*/}
          {/*                  ?.desk_img*/}
          {/*          }`,*/}
          {/*        ]*/}
          {/*      : selectedColor?.imgArr*/}
          {/*  }*/}
          {/*/>*/}
          
          {/* For Showing the exterior image */}
           <ReactImageTurntable
             autoRotate={{ disabled: true }}
             style={{ minHeight: "50vh", height: "100%" }}
             images={
               props?.configuratorData?.ExtStaticImageToggle
                ? [
                      mobile
                        ? selectedColor?.staticExtImageMobile
                        : selectedColor?.staticExtImageDesktop
                    ,
                  ]
                : selectedColor?.imgArr
            }
          />
          {/* <ReactImageTurntable
            autoRotate={{ disabled: true }}
            // style={{ minHeight: "50vh", height: "100%" }}
            images={selectedColor?.imgArr}
          /> */}
          {overlayVisibility && !selectedColor?.extStaticImage && !props?.configuratorData?.ExtStaticImageToggle && (
            <img
              className="absolute left-[50%] top-[50%] translate-x-[-50%] translate-y-[-50%] h-[6rem] lg:h-[10rem] w-[6rem] lg:w-[10rem]"
              // src="/assets/images/360-overlay.svg"
              src={`${configuration.IMG_STATIC_URL}assets/images/360-overlay.svg`}
              alt=""
            />
          )}
        </div>
      </div>
      <div className="lg:col-span-4 lg:mt-0 mt-8 col-span-12 justify-center flex items-center">
        <div className="w-[65%]">
        <div className="font-suzukiBold text-sub-heading uppercase text-[#001151] my-3">
             {CAR_CONTANTS?.Constants?.carConfigurator?.CHOOSE_VARIANT}
           </div>
           <SelectInput
                 onChange={(e)=>handleSelectChange(e)}
                 items={props.variantsData.map((item, index) =>
                   index === 0 ? { ...item, selected: true } : item
                 )}
                 placeholder={CAR_CONTANTS?.Constants?.carConfigurator?.CHOOSE_VARIANT}
                 isPlaceholderDisabled={true}
               />
           <div className="font-suzukiBold text-sub-heading uppercase text-[#001151] mt-8 mb-3">
	             {CAR_CONTANTS?.Constants?.carConfigurator?.CHOOSE_COLOR}
            
          </div>
          <div className="flex w-full justify-center">
            <div
                className={`flex gap-y-5 gap-x-4 flex-wrap`}
              style={{
                width: `${
                  colorsArr.length > 4
                    ? "100%"
                    : circleContainerWidth[colorsArr.length]
                }`,
                gridTemplateColumns: `repeat(auto-fill, minmax(calc(${
                  colorsArr.length > 4 ? "25%" : circleLength[colorsArr.length]
                } - 10px), 1fr))`,
              }}
            >
              {console.log("colorArray",colorArray)}
              {colorArray?.map((x, index) => (
                <div
                  key={index}
                  className={`rounded-full w-fit p-1 border-2 ${
                    selectedColor.index === index
                      ? "border-primary-blue"
                      : "border-transparent"
                  }`}
                >
                  <div
                    className="w-9 md:w-10 lg:w-11 h-9 md:h-10 lg:h-11 rounded-full cursor-pointer"
                    onClick={() =>{
                      setSelectedColor({
                        name: x.name,
                        index: index,
                        imgArr: x?.extStaticImage
                          ? isMobile
                            ? x?.staticExtImageMobile
                            : x?.staticExtImageDesktop
                          : x.exteriorImages,
                        extStaticImage: x?.extStaticImage,
                        staticExtImageDesktop: x?.staticExtImageDesktop[0],
                        staticExtImageMobile: x?.staticExtImageMobile[0]            
                      })}
                    }
                    style={{
                      // background: x.value,
                      background: `linear-gradient(to right, ${x.value1 ? x.value1 : x.value2} 50%, ${x.value2 ? x.value2 : x.value1 } 50%)`,
                      boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
                    }}
                  ></div>
                </div>
              ))}
            </div>
          </div>
          <div className="flex mt-5 w-full justify-center">
            <div className="font-suzukiBold text-default">
              {selectedColor.name}
            </div>
          </div>
          <p className="font-suzukiRegular text-default mt-8">
              {CAR_CONTANTS?.Constants?.carConfigurator?.COLOR_VARIANT_DISCLAIMER}
            </p>
        </div>
      </div>
    </div>
  );
};
export default ExteriorViewer;
